const emptyState = () => ({
  pageTitle: '',
  errors: []
})

export default {
  namespaced: true,
  state: emptyState(),
  mutations: {
    SET_PAGE_TITLE (state, pageTitle) {
      state.pageTitle = pageTitle
    },
    SET_SECTION_ERROR (state, { id, hasError }) {
      let index = state.errors.indexOf(id)
      if (hasError) {
        if (index === -1) {
          state.errors.push(id)
        }
      } else {
        if (index !== -1) {
          state.errors.splice(index, 1)
        }
      }
    }
  },
  getters: {
    hasErrors: state => state.errors.length > 0
  },
  actions: {
    setPageTitle ({ commit, dispatch }, pageTitle) {
      commit('SET_PAGE_TITLE', pageTitle)
    }
  }
}
